import { capitalize, Tooltip } from '@mui/material';

import {
  jobIconStatusMap,
  jobStatusColorMap,
  dateFormatString,
} from '../utils';

import { format as formatTZ, formatInTimeZone } from 'date-fns-tz';
import { formatDistance, parseISO, parseJSON } from 'date-fns';
import CronTableCellDisplay from '../CronTableCellDisplay';

import { Link } from '../../../utils/theme';

const getSyncTableColumns = (
  settings: { timeZone: { current: string } },
  currentAccount: { id: string; name?: string },
  flowName: string | undefined,
) => {
  const columns = [
    {
      field: 'status',
      headerName: 'Status',
      type: 'singleSelect',
      valueOptions: [
        'failed',
        'success',
        'running',
        'queued',
        'dequeued',
        'retry',
        'pushed',
      ],
      sortable: false,
      width: 100,
      renderCell: (params: { value: string }) => (
        <span
          style={{
            color: (jobStatusColorMap as Record<string, string>)[params.value],
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {(jobIconStatusMap as Record<string, React.ReactNode>)[params.value]}{' '}
          <small style={{ paddingLeft: '5px' }}>
            {capitalize(params.value)}
          </small>
        </span>
      ),
    },

    {
      field: 'id',
      headerName: 'ID',
      width: 120,
      filterable: true,
      sortable: false,
      renderCell: (params: any) => (
        <Link
          to={`/${currentAccount.name}/flows/${flowName}/syncs/${params.value}`}
        >
          {params.value.split('-')[params.value.split('-').length - 1]}
        </Link>
      ),
    },

    {
      field: 'schedule',
      sortable: false,
      filterable: false,
      headerName: 'Schedule',
      width: 350,
      renderCell: (params: any) => <CronTableCellDisplay params={params} />,
    },

    {
      field: 'started_at',
      headerName: 'Started',
      width: 220,
      sortable: true,
      filterable: false,
      renderCell: (params: { value?: string }) => (
        <Tooltip title={(params?.value ?? '') + ' UTC'}>
          <span>
            {params?.value
              ? formatInTimeZone(
                  parseJSON(params?.value),
                  settings.timeZone.current,
                  dateFormatString,
                )
              : ''}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'ended_at',
      headerName: 'Ended',
      sortable: true,
      filterable: false,
      width: 220,
      renderCell: (params: { value?: string }) => (
        <Tooltip title={(params?.value ?? '') + ' UTC'}>
          <span>
            {params?.value
              ? formatInTimeZone(
                  parseJSON(params?.value),
                  settings.timeZone.current,
                  dateFormatString,
                )
              : ''}
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'run_time',
      headerName: 'Run time',
      filterable: false,
      sortable: false, //TODO: maybe sort by relative time asc/desc in ms
      width: 200,
      valueGetter: (
        _value: any,
        row: { ended_at?: string; started_at?: string },
      ) =>
        row?.ended_at &&
        row?.started_at &&
        formatDistance(parseJSON(row.ended_at), parseJSON(row.started_at)),
    },
  ];

  return columns;
};

export default getSyncTableColumns;
